import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import SharedCharts from '../pages/SharedCharts';
import ChartResults from '../pages/ChartResults';
import ResetPassword from '../pages/ResetPassword';
import ChartStats from '../pages/ChartStats';
import ChartCompare from '../pages/ChartCompare';
import Layout from '../containers/Layout';
import ForgotPassword from '../pages/ForgotPassword';

const mainRouter = createBrowserRouter([
    {
        path: '/',
        errorElement: (
            <div className="text-primary text-3xl text-center">
                404 Not Found
            </div>
        ),
        element: (
            <Layout>
                <SharedCharts />
            </Layout>
        ),
    },
    {
        path: 'shared-charts',
        element: (
            <Layout hasBackButton>
                <ChartResults />
            </Layout>
        ),
    },
    {
        path: 'reset-password',
        element: (
            <Layout>
                <ResetPassword />
            </Layout>
        ),
    },
    {
        path: 'forgot-password',
        element: <ForgotPassword />,
    },
    {
        path: 'stats',
        element: (
            <Layout hasBackButton>
                <ChartStats />
            </Layout>
        ),
    },
    {
        path: 'compare',
        element: (
            <Layout hasBackButton>
                <ChartCompare />
            </Layout>
        ),
    },
]);

export default mainRouter;
